import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

function useFirebase(onSave: (token: any) => void) {
  const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);
  onMessage(messaging, (payload) => {
    console.log("Message received. ", payload);
    // ...
  });
  function requestPermission() {
    Notification.requestPermission()
      .then(async (permission) => {
        if (permission === "granted") {
          console.log("Notification permission granted.");
          // Obtener el token de registro para la instancia del servicio de mensajería de Firebase
          const token = await getToken(messaging, {
            vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VALID_KEY,
          });
          if (token) {
            console.log(token);
            onSave(token);
          } else {
            console.log("No FCM token available.");
          }
          return token;
        }
      })
      .catch((error) => {
        console.error("Error requesting permission:", error);
      });
  }
  return { requestPermission };
}

export default useFirebase;
